const DateQuery = (year, month, day = -1) => ({
  year,
  month,
  day,
});

export default DateQuery;
